import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const createAvailabilitiesList = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/meetings/availabilities/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createMeeting = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/meetings/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateMeeting = ({ version = 'v1', id, payload }) =>
  client
    .request({
      url: `${version}/meetings/${id}/`,
      method: RequestMethod.PUT,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createAvailabilityType = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-templates/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAvailabilityTypeById = ({ version = 'v1', id } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-templates/${id}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAvailabilityType = ({ id, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-templates/${id}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteAvailabilityType = ({ id, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-templates/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAvailabilitiesList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-templates/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAvailabilitiesSlots = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-slots/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSlot = ({ version = 'v1', id } = {}) =>
  client
    .request({
      url: `${version}/meetings/availability-slots/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEventsList = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/meetings/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentSearchList = ({
  version = 'v1',
  params = { limit: 10 },
} = {}) =>
  client
    .request({
      url: `${version}/message-center/students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getExternalCalendars = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/third-party-calendars/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createThirdPartyCalendar = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/third-party-calendars/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const removeThirdPartyCalendar = ({ version = 'v1', id } = {}) =>
  client
    .request({
      url: `${version}/third-party-calendars/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const cancelMeeting = ({ version = 'v1', id, payload } = {}) =>
  client.request({
    url: `${version}/meetings/${id}/cancel/`,
    method: RequestMethod.POST,
    data: payload,
  });

export const blockSlot = ({ version = 'v1', payload } = {}) =>
  client.request({
    url: `${version}/meetings/block/`,
    method: RequestMethod.POST,
    data: payload,
  });

export const unblockSlot = ({ version = 'v1', id } = {}) =>
  client.request({
    url: `${version}/meetings/${id}/unblock/`,
    method: RequestMethod.POST,
  });

export const messageStudent = ({ version = 'v1', payload } = {}) =>
  client.request({
    url: `${version}/message-center/message/`,
    method: RequestMethod.POST,
    data: payload,
  });

export const toggleThirdPartyCalendarHidden = ({
  version = 'v1',
  id,
  payload,
}) =>
  client.request({
    url: `${version}/third-party-calendars/${id}/`,
    method: RequestMethod.PATCH,
    data: payload,
  });
